module.exports = __webpack_public_path__ + "daa64ee9f36efcf328b9e8393a6de2c8.jpg";